import axios from "axios";
const url = process.env.REACT_APP_BASE_API_URL;

// export const missingDirectoryDownloadXmlFromBackEnd = async (trkid) => {
//     //    const trkFile = trkid + "S.Img";
//     const url2 = `${url}/v2/container/downloadxml/${trkid}`;
//     console.log("Veio para o container", url2);
//     const headers = {
//         responseType: "blob",
//         "Content-Type": "application/octet-stream",
//     };
//     const res = await axios.get(url2, headers);
//     return res.data;
// };

export const downloadMissingDirectory = async (
    sitId,
    dti,
    dtf
) => {
    if (!sitId) {
        sitId = "None";
    }

    const res = await axios.get(
        url + `/v1/missingdirectory-download-xml/${sitId}/${dti}/${dtf}`,
        {
            responseType: "blob",
            headers: { "Content-Type": "application/octet-stream" },
        }
    );

    const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "missing_directory.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
};